module.exports = {
	"id": "BY",
	"name": "Belarus",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.213925,
			"5": 0.17114,
			"6": 0.179697,
			"7": 0.154026,
			"8": 0.08557,
			"9": 0.128355,
			"10": 0.136912,
			"11": 0.162583,
			"12": 0.213925,
			"13": 0.25671,
			"14": 0.222482,
			"15": 0.333723,
			"16": 0.290938,
			"17": 0.376508,
			"18": 0.410736,
			"19": 0.316609,
			"20": 0.359394,
			"21": 0.521977,
			"22": 0.42785,
			"23": 0.496306,
			"24": 0.402179,
			"25": 0.367951,
			"26": 0.299495,
			"27": 0.34228,
			"28": 0.179697,
			"29": 0.094127,
			"30": 0.059899,
			"31": 0.119798,
			"32": 0.068456,
			"33": 0.111241,
			"34": 0.077013,
			"35": 0.231039,
			"36": 0.119798,
			"37": 0.059899,
			"38": 0.17114,
			"39": 0.350837,
			"40": 0.51342,
			"41": 0.282381,
			"42": 0.25671,
			"43": 0.333723,
			"44": 0.025671,
			"45": 0.145469,
			"46": 0.034228,
			"47": 0.145469,
			"48": 0.145469,
			"49": 2.070794,
			"50": 0.145469,
			"51": 0.547648,
			"52": 0.496306,
			"53": 18.919527,
			"54": 5.47648,
			"55": 0.239596,
			"56": 0.068456,
			"57": null
		},
		"firefox": {
			"2": 0.273824,
			"3": 0.795801,
			"4": 0.154026,
			"5": 0.051342,
			"6": 0.068456,
			"7": 0.025671,
			"8": 0.08557,
			"9": 0.059899,
			"10": 0.128355,
			"11": 0.059899,
			"12": 0.068456,
			"13": 0.051342,
			"14": 0.128355,
			"15": 0.111241,
			"16": 0.102684,
			"17": 0.051342,
			"18": 0.051342,
			"19": 0.102684,
			"20": 0.102684,
			"21": 0.136912,
			"22": 0.051342,
			"23": 0.094127,
			"24": 0.051342,
			"25": 0.077013,
			"26": 0.051342,
			"27": 0.025671,
			"28": 0.042785,
			"29": 0.025671,
			"30": 0.034228,
			"31": 0.068456,
			"32": 0.068456,
			"33": 0.111241,
			"34": 0.102684,
			"35": 0.179697,
			"36": 0.145469,
			"37": 0.068456,
			"38": 0.08557,
			"39": 0.025671,
			"40": 0.025671,
			"41": 0.017114,
			"42": 0.025671,
			"43": 0.102684,
			"44": 0.051342,
			"45": 0.154026,
			"46": 0.068456,
			"47": 0.496306,
			"48": 0.231039,
			"49": 4.133031,
			"50": 0.025671,
			"51": null,
			"52": null,
			"3.5": 1.266436,
			"3.6": 3.474142
		},
		"opera": {
			"9": null,
			"11": 0.188254,
			"12": 1.386234,
			"15": 0.017114,
			"16": 0.042785,
			"17": 0.042785,
			"18": 0.145469,
			"19": 0.077013,
			"20": 0.162583,
			"21": 0.051342,
			"22": 0.051342,
			"23": 0.051342,
			"24": 0.119798,
			"25": 0.119798,
			"26": 0.094127,
			"27": 0.744459,
			"28": 0.094127,
			"29": 0.051342,
			"30": 0.077013,
			"31": 0.025671,
			"32": 0.025671,
			"33": 0.042785,
			"34": 0.059899,
			"35": 0.059899,
			"36": 0.838586,
			"37": 0.196811,
			"38": 0.128355,
			"39": 0.128355,
			"40": 4.346956,
			"41": 0.753016,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.205368,
			"10.5": 0.196811,
			"10.6": 0.479192,
			"11.1": 0.17114,
			"11.5": 0.402179,
			"11.6": 1.052511,
			"12.1": 3.859207
		},
		"safari": {
			"0": null,
			"4": 0.470635,
			"5": 0.812915,
			"6": 0.128355,
			"7": 0.068456,
			"8": 0.094127,
			"9": 0.034228,
			"10": 0.479192,
			"3.1": 0.136912,
			"3.2": 0.068456,
			"5.1": 0.51342,
			"6.1": 0.059899,
			"7.1": 0.034228,
			"9.1": 0.213925
		},
		"ios_saf": {
			"8": 0,
			"10": 1.15036660616,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0310010489176,
			"8.1-8.4": 0.0572731242714,
			"9.0-9.2": 0.027322958368,
			"9.3": 0.416850262281
		},
		"android": {
			"3": 0,
			"4": 0.0226919379845,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00283649224806,
			"4.1": 0.0818530620155,
			"4.2-4.3": 0.204632655039,
			"4.4": 0.469236860465,
			"4.4.3-4.4.4": 0.473288992248
		},
		"ie": {
			"6": 0.00950777777778,
			"7": 0.0190155555556,
			"8": 0.960285555556,
			"9": 0.570466666667,
			"10": 1.06487111111,
			"11": 1.39764333333,
			"5.5": null
		},
		"op_mob": {
			"0": 0.092880821555,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00258002282097
		},
		"edge": {
			"12": 0.034228,
			"13": 0.119798,
			"14": 0.290938
		},
		"ie_mob": {
			"10": 0.0753495774648,
			"11": 0.306780422535
		},
		"bb": {
			"7": 0.001442,
			"10": null
		},
		"samsung": {
			"0": 0.664762
		},
		"and_uc": {
			"0": 0.357616
		},
		"op_mini": {
			"0": 1.25136715562
		},
		"and_chr": {
			"0": 9.500049
		},
		"and_ff": {
			"0": 0.004326
		}
	},
	"total": 91.617074
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BY.json
 ** module id = 487
 ** module chunks = 0
 **/